var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuIcon = function SvgMenuIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M19.165 12.5a5 5 0 1 1-10 0 5 5 0 0 1 10 0M25 31.44c0-5.858-4.749-10.607-10.606-10.607h-.455c-5.857 0-10.606 4.749-10.606 10.606 0 .586.475 1.061 1.06 1.061h19.546a1.06 1.06 0 0 0 1.06-1.06m.834-19.773h10.001a.833.833 0 0 0 0-1.667h-10a.833.833 0 0 0 0 1.667m0 9.17h10a.833.833 0 1 0 0-1.667h-10a.833.833 0 0 0 0 1.667m2.5 8.333c0-.46.373-.833.834-.833h6.668a.833.833 0 1 1 0 1.666h-6.668a.833.833 0 0 1-.834-.833",
    clipRule: "evenodd"
  })));
};
export default SvgMenuIcon;